import React from "react";
import { Translate } from "../../../../language";
import Botton from "../../../../utils/components/Button/Button";
import InputSearch from "../../../../utils/components/InputSearch/InputSearch";
import CardList from "../../../../utils/components/CardList/CardList";
import "./Winery.css";
import cardStyle from ".././CardListWineries.module.css";
import { useHistory } from "react-router-dom";
import { SubWineryIcon } from "../../../../assets/icons";
import TitleSVG from "../../../../utils/components/TitleSVG/TitleSVG";


const Winery = ({
  setCodeName,
  codeName = '',
  hadleClick = () => { },
  listProducts = [],
  id,
  title,
}) => {
  const history = useHistory()
  return (
    <>
      <TitleSVG
        Icon={SubWineryIcon}
        titleHighlight={Translate("subWineries", "es")}
      />

      <div className="content-create-winery">
        <div className="content-principal-winery">

          <Botton text={Translate("create", "es")} styles={{ width: '70%', margin: '4vw auto 2vw auto' }}
            onClick={() => {
              history.push(`/Admin/Inventory/CreateSubWinery/${id}`)
            }}
          />
          <InputSearch
            searchData={data => {
              setCodeName(data)
            }}
            placeholder={Translate("searchIn", "es") + Translate("subWinery", "es").toLowerCase()}
            classNameContent="white"
            isDrowMenu={false}
          />
        </div>
        {(listProducts.length ===0) ?
          <div>
            {
              codeName ==='' ?
                <div className={`text-warning`}>No hay SubBodegas para mostrar</div> :
                <div className={`text-warning`}>La busqueda '{codeName}' no ha arrojado resultados</div>
            }
          </div> :
          <div className="content-list-winery scroll-menu">
            {listProducts.map(list =>
            <CardList
              Icon={SubWineryIcon}
              style={cardStyle}
              key={list._id} textOne={list.name}
              hasOnClick={false} />
            )}
          </div>}
      </div>

    </>
  );
};

export default Winery;
